// extracted by mini-css-extract-plugin
export var dropdown = "_f7-0";
export var imagePlaceholder = "_f7-2";
export var imageWrapper = "_f7-3";
export var productImage = "_f7-1";
export var truncateContainer = "_f7-4";
export var truncateText = "_f7-5";